import React from 'react';
import { Link } from 'react-router-dom';

/** Dashboard metric card. The whole card is a link to the metric's history page. */
const StatTile: React.FC<{ to: string; label: string; value: React.ReactNode; hint?: React.ReactNode }> = ({ to, label, value, hint }) => (
  <Link to={to} className="surface stat-link">
    <div className="stat-label">{label}</div>
    <div className="stat-value tabular">{value}</div>
    {hint && <div className="stat-hint">{hint}</div>}
    <span className="stat-link-chevron" aria-hidden="true">
      ›
    </span>
  </Link>
);

export default StatTile;
